// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome-modal__card {
    padding: 16px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: var(--space-half);
    margin-bottom: var(--space-half-quarter);
    cursor: pointer;
}

.welcome-modal__card-title {
    display: flex;
    align-items: center;
    margin-bottom: var(--space-half);
}

.welcome-modal__card-title .welcome-modal__card-icons {
    margin-right: var(--space-half);
    color: var(--white-color);
    border-radius: 50%;
    width: var(--space-x2);
    height: var(--space-x2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: var(--space-and-half);
}

.welcome-modal__card-title span.icon-web {
    background-color: #00B9D2;    
}

.welcome-modal__card-title span.icon-user {
    background-color: #F65D23;
}

.welcome-modal__card .hubicon-create_team,
.welcome-modal__card .hubicon-join_team,
.welcome-modal__card .hubicon-tournaments {
    font-size: var(--space-x2);
    margin-right: var(--space-half);
}

.welcome-modal__title-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: var(--space-and-half);
}

.welcome-modal__title-container .hubicon-baloa_logo {
    font-size: 80px;
    margin: var(--space-and-half) 0;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ 

    .welcome-modal__card-title .baloa-table-column {
        font-size: calc( var(--space) var(--space-half) - 2px );
    }
    .welcome-modal__card-title .baloa-username {
        font-size: var(--space);
    }
    .welcome-modal__card-title .baloa-table {
        font-size: calc( var(--space) + 2px );
        font-weight: var(--font-medium);
    }
    .welcome-modal__title-container .hubicon-baloa_logo {
        font-size: 32px;
        margin: var(--space-and-half) 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/components/welcome-modal/WelcomeModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kDAAkD;IAClD,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,0BAA0B;IAC1B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,uDAAuD;IAC3D;IACA;QACI,uBAAuB;IAC3B;IACA;QACI,qCAAqC;QACrC,+BAA+B;IACnC;IACA;QACI,eAAe;QACf,+BAA+B;IACnC;AACJ","sourcesContent":[".welcome-modal__card {\n    padding: 16px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: var(--space-half);\n    margin-bottom: var(--space-half-quarter);\n    cursor: pointer;\n}\n\n.welcome-modal__card-title {\n    display: flex;\n    align-items: center;\n    margin-bottom: var(--space-half);\n}\n\n.welcome-modal__card-title .welcome-modal__card-icons {\n    margin-right: var(--space-half);\n    color: var(--white-color);\n    border-radius: 50%;\n    width: var(--space-x2);\n    height: var(--space-x2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: var(--space-and-half);\n}\n\n.welcome-modal__card-title span.icon-web {\n    background-color: #00B9D2;    \n}\n\n.welcome-modal__card-title span.icon-user {\n    background-color: #F65D23;\n}\n\n.welcome-modal__card .hubicon-create_team,\n.welcome-modal__card .hubicon-join_team,\n.welcome-modal__card .hubicon-tournaments {\n    font-size: var(--space-x2);\n    margin-right: var(--space-half);\n}\n\n.welcome-modal__title-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: var(--space-and-half);\n}\n\n.welcome-modal__title-container .hubicon-baloa_logo {\n    font-size: 80px;\n    margin: var(--space-and-half) 0;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */ \n\n    .welcome-modal__card-title .baloa-table-column {\n        font-size: calc( var(--space) var(--space-half) - 2px );\n    }\n    .welcome-modal__card-title .baloa-username {\n        font-size: var(--space);\n    }\n    .welcome-modal__card-title .baloa-table {\n        font-size: calc( var(--space) + 2px );\n        font-weight: var(--font-medium);\n    }\n    .welcome-modal__title-container .hubicon-baloa_logo {\n        font-size: 32px;\n        margin: var(--space-and-half) 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
